module.exports = "/packs/type-of-coaching-image-ce91c77dc1eaf56181cc585095720705.png";